import { render, staticRenderFns } from "./teskManage.vue?vue&type=template&id=9a4e9f6a&scoped=true&"
import script from "./teskManage.vue?vue&type=script&lang=js&"
export * from "./teskManage.vue?vue&type=script&lang=js&"
import style0 from "./teskManage.vue?vue&type=style&index=0&id=9a4e9f6a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a4e9f6a",
  null
  
)

export default component.exports